<template>
  <div class="app-mnp-in-wrapper" v-if="showMNP">
    <!-- PAGE 1: Start -->
    <div class="mnpIn-Start overview-process" v-if="!openSuccess">
      <div class="accordion-header">
          <slot name="txtAccordionHeaderStart"></slot>
        <b-btn
          @click="goToStep(startStepName)"
          class="accordion-toggle"
          v-if="editButtonStart"
          >zurück</b-btn
        >
      </div>
      <b-collapse v-model="openInfo">
        <MnpInStart
          :portation-time.sync="portationTime"
          :portation-consent.sync="portationConsent"
          :next-step="dataStepName"
        >
          <template
            v-for="slot in possibleChildSlotsFor('Start')"
            v-slot:[`${slot.child}`]
          >
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </MnpInStart>
      </b-collapse>
    </div>

    <!-- PAGE 2: Data -->
    <div class="mnpIn-Data overview-process" v-if="!openSuccess">
      <div class="accordion-header">
        <slot name="txtAccordionHeaderData"></slot>
        <b-btn
          @click="goToStep(dataStepName)"
          class="accordion-toggle"
          v-if="editButtonData"
          >zurück</b-btn
        >
      </div>
      <b-collapse v-model="openPersonalData">
        <MnpInData
          :portation-time.sync="portationTime"
          :previous-step="startStepName"
          :next-step="summaryStepName"
        >
          <template
            v-for="slot in possibleChildSlotsFor('Data')"
            v-slot:[`${slot.child}`]
          >
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </MnpInData>
      </b-collapse>
    </div>

    <!-- PAGE 3: Summary -->
    <div class="mnpIn-Summary overview-process" v-if="!openSuccess">
      <div class="accordion-header">
        <slot name="txtAccordionHeaderSummary"></slot>
        <b-btn
          @click="goToStep(summaryStepName)"
          class="accordion-toggle"
          v-if="editButtonSummary"
        >zurück</b-btn
        >
      </div>
      <b-collapse v-model="openSummary">
        <MnpInSummary :previous-step="dataStepName">
          <template
            v-for="slot in possibleChildSlotsFor('Summary')"
            v-slot:[`${slot.child}`]
          >
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </MnpInSummary>
      </b-collapse>
    </div>

    <!-- PAGE 4: Success -->
    <div class="mnpIn-Success overview-process" v-if="openSuccess">
      <div class="accordion-header">
        <slot name="txtAccordionHeaderSuccess"></slot>
      </div>
      <b-collapse v-model="openSuccess">
        <MnpInSuccess :previous-step="summaryStepName">
          <template
            v-for="slot in possibleChildSlotsFor('Success')"
            v-slot:[`${slot.child}`]
          >
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </MnpInSuccess>
      </b-collapse>
    </div>
  </div>
  <div v-else>
    <slot name="infoMnpInNotAvailable">
      <h2>Rufnummernmitnahme in diesem Tarif nicht möglich</h2>
    </slot>
  </div>
</template>

<script>
import MnpInStart, {
  stepName as startStepName
} from '@/components/process/generic/Mnp/MnpIn/fyve/Start.vue'
import MnpInData, {
  stepName as dataStepName
} from '@/components/process/generic/Mnp/MnpIn/fyve/Data.vue'
import MnpInSummary, {
  stepName as summaryStepName
} from '@/components/process/generic/Mnp/MnpIn/fyve/Summary.vue'
import MnpInSuccess, {
  stepName as successStepName
} from '@/components/process/generic/Mnp/MnpIn/fyve/Success.vue'
import slotProxy from '@/mixins/slotProxy'
import processWrapper from '@/mixins/processWrapper'
import transaction from '@/mixins/transaction'
import { mapGetters, mapMutations } from 'vuex'
import gql from 'graphql-tag'
import { wrapQuery } from '../../../../../../helper/wrapGQLQuery'
import extraData from '../../../../../../mixins/extraData'

const computedAccordionOpen = function (stepName) {
  return {
    get () {
      return this.currentStep === stepName
    },
    set () {} // dummy setter for v-model bind
  }
}

const computedEditButton = function (stepName) {
  return {
    get () {
      if (this.currentStep !== 'mnpInSuccess') {
        return (processSteps.indexOf(this.currentStep) > processSteps.indexOf(stepName))
      } else {
        return false
      }
    }
  }
}

const processSteps = [startStepName, dataStepName, summaryStepName, successStepName]
export default {
  name: 'MnpInWrapper',
  import: {
    startStepName,
    dataStepName,
    summaryStepName
  },
  data () {
    return {
      portationTime: 'CONTRACT_END',
      portationConsent: false,
      tariffs: null
    }
  },
  methods: {
    ...mapMutations('mnpIn', ['goToStep'])
  },
  computed: {
    ...mapGetters('mnpIn', {
      currentStep: 'showMnpInView'
    }),
    tariffsExtra: function () {
      return this.extraData.find(
        item => item.id === this.tariffs?.bookedTariff?.tariffId
      )
    },
    showMNP: function () {
      return this.tariffsExtra?.type !== 'year'
    },
    // open status for accordions
    openInfo: computedAccordionOpen.bind(this)(startStepName),
    openPersonalData: computedAccordionOpen.bind(this)(dataStepName),
    openSummary: computedAccordionOpen.bind(this)(summaryStepName),
    openSuccess: computedAccordionOpen.bind(this)(successStepName),

    // open status for accordions
    editButtonStart: computedEditButton.bind(this)(startStepName),
    editButtonData: computedEditButton.bind(this)(dataStepName),
    editButtonSummary: computedEditButton.bind(this)(summaryStepName)
  },
  apollo: {
    tariffs: function () {
      return wrapQuery(
        gql`
          query MnpIn {
            tariffs {
              bookedTariff {
                tariffId
              }
            }
          }
        `,
        this,
        'tariffs'
      )
    }
  },
  components: {
    MnpInStart,
    MnpInData,
    MnpInSummary,
    MnpInSuccess
  },
  mixins: [
    transaction('mnpIn'),
    slotProxy(),
    processWrapper('showMnpInView'),
    extraData()
  ]
}
</script>
